import debug from "debug";

export const INFO = debug("[app info]:green")
export const WARN = debug("[app warn]:yellow")
export const ERROR = debug("[app error]:red")
